<template>
  <div v-if="!isSymposium" class="wrap-banner">
    <Logo />
    <Carousel />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Logo from './Logo'
import Carousel from './Carousel'

export default {
  components: {
    Logo,
    Carousel
  },

  computed: {
    ...mapState({
      isSymposium: state => state.symposium.isSymposium
    }),
  },
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 767px) {
  .wrap-banner {
    padding-top: 55px;

    .wrap-logo {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 19;
      width: 100%;
      background-color: white;
    }
  }
}
</style>
